function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickerPause01 = function SvgTickerPause01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M78.57 21.43v157.14c0 11.83-9.59 21.43-21.43 21.43H50c-11.83 0-21.43-9.59-21.43-21.43V21.43C28.57 9.59 38.17 0 50 0h7.14c11.83 0 21.43 9.59 21.43 21.43M150 0h-7.14c-11.83 0-21.43 9.59-21.43 21.43v157.14c0 11.83 9.59 21.43 21.43 21.43H150c11.83 0 21.43-9.59 21.43-21.43V21.43C171.43 9.6 161.84 0 150 0",
    style: {
      fill: "#b45fff"
    }
  }));
};
export default SvgTickerPause01;